import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getOtherPayees = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/OtherPayee/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching other payees:", error);
    throw error;
  }
};

export const saveOtherPayee = async (otherPayeeData) => {
  const response = await axios.post(`${BASE_URL}/api/OtherPayee/save`, otherPayeeData, {
    headers: getAuthHeader(),
  });
  return response.data;
};



